import service from '../utils/request'
import { login } from './login'

// 用户信息接口
export interface UserInfo {
  id: string
  username: string
  email?: string
  phone?: string
  status?: number
  roleId?: string
  totpEnabled?: boolean
  createdAt?: string
  updatedAt?: string
}

class UserService {
  // 获取用户信息
  async getUserInfo(): Promise<UserInfo> {
    return await service.get('/admin/myinfo')
  }

  // 轮询用户信息，如果连续五次发生错误，跳转到登录页面
  startPollingUserInfo(interval = 60000): { stop: () => void } {
    let timerId: number | null = null
    let failureCount = 0 // 添加失败计数器
    const MAX_FAILURES = 5 // 最大失败次数

    // 定义轮询函数
    const poll = async () => {
      try {
        await this.getUserInfo()
        // 成功获取用户信息，重置失败计数
        failureCount = 0
      } catch (error) {
        // 失败计数增加
        failureCount++

        // 只有连续失败达到阈值才跳转到登录页面
        if (failureCount >= MAX_FAILURES) {
          // 出错时跳转到登录页面
          // 注意：实际上响应拦截器可能已经处理了跳转，这里是额外保障
          login.logout()
          failureCount = 0 // 重置计数器
        }
      }
    }

    // 立即执行一次
    poll()

    // 设置定时器
    timerId = window.setInterval(poll, interval)

    // 返回停止函数
    return {
      stop: () => {
        if (timerId !== null) {
          window.clearInterval(timerId)
          timerId = null
        }
      },
    }
  }
}

// 导出单例实例
export const userService = new UserService()
